import { Flex, Text } from '@chakra-ui/react'

import { useDeleteCollection } from '@/api/collections'
import Button from '@/components/ui/Button'
import Modal from '@/components/ui/Modal'

import type { Collection } from '@/api/collections'

interface DeleteGroupModalProps {
  isOpen: boolean
  onClose: () => void
  collection: Collection | null
}

export default function DeleteGroupModal({
  isOpen,
  onClose,
  collection
}: DeleteGroupModalProps) {
  const deleteCollection = useDeleteCollection()

  const isDeleting = deleteCollection.isPending

  const handleProceed = async () => {
    if (!collection || isDeleting) return

    await deleteCollection.mutateAsync(collection.id)
    onClose()
  }

  const handleClose = () => {
    if (isDeleting) return
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={`Are You Sure You Want To Delete "${collection?.name ?? ''}"`}
    >
      <Text textStyle="body" color="secondaryDarkGray.600">
        Deleting this IP group will remove all associated graphics.
        This action cannot be undone.
      </Text>

      <Flex mt={5} gap={3}>
        <Button
          variant="secondary"
          flex="1"
          onClick={handleClose}
          disabled={isDeleting}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          flex="1"
          onClick={handleProceed}
          loading={isDeleting}
        >
          Proceed
        </Button>
      </Flex>
    </Modal>
  )
}
